module.exports = __webpack_public_path__ + "img/logo1.71050263.jpg";